/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 14:19:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-31 17:15:51
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/CustomerDatabaseSiderConfig.tsx
 */

import React from 'react';
import { get } from 'lodash';
import { Icon } from '@/src/tools/icon';
import { DesktopOutlined } from '@ant-design/icons';
import { useFetchCurrentDatabase } from '@/src/constrains/CustomerDBGetter/useGetCustomerDB';
import { useSelector } from 'react-redux';
import { getCurrentDatabase } from '@/src/constrains/CustomerDBGetter/slice';
//import { useClearSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import {
  customerTag,
  databaseSetting,
  customerList,
} from 'src/tools/permissions/storeSiderPermission';
import { EPermissionSource } from 'src/types/common/resources';
import { storeDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';

export const menuArray = ({ customerDatabaseUuid }) => {
  const currentDatabase = useSelector(getCurrentDatabase());
  useFetchCurrentDatabase({ uuid: customerDatabaseUuid, forceUpdate: true });
  // useClearSalesChannel();

  return [
    {
      path: '/customerDatabase',
      iconType: <DesktopOutlined />,
      name: getI18nFromGeneral('general.sider.backToStore'), //'Back to Store',
      key: 'customerGoBack',
      splitLine: true,
      routers: [],
    },
    {
      textOnly: true,
      splitLine: true,
    },
    {
      text: get(currentDatabase, 'databaseName', ''),
      textOnly: true,
    },
    {
      path: `/customerDatabase/customerList/${customerDatabaseUuid}`,
      iconType: <Icon type='iconcontent1' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.customerList'),
      key: 'customerList',
      source: EPermissionSource.store,
      permissionGroup: customerList,
      routers: storeDict.customers,
      // [
      //   '/customerDatabase/customerList/*',
      //   '/customerDatabase/customerDetail/*/*',
      // ],
    },
    {
      path: `/customerDatabase/databaseSettings/${customerDatabaseUuid}`,
      iconType: <Icon type='iconproducts' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.dataBaseSettings'),
      key: 'databaseSettings',
      source: EPermissionSource.store,
      permissionGroup: databaseSetting,
      routers: storeDict.customerDatabase,
      // [
      //   '/customerDatabase/databaseSettings/*',
      //   '/customerDatabase/databaseSettings/*/*',
      // ],
    },
    {
      path: `/customerDatabase/tagList/${customerDatabaseUuid}`,
      iconType: <Icon type='iconproducts' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.customerTag'),
      key: 'databaseSettingsTag',
      source: EPermissionSource.store,
      permissionGroup: customerTag,
      routers: storeDict.customerTag, //['/customerDatabase/tagList/*', '/customerDatabase/tagEdit/*/*'],
    },
  ];
};
